import React from 'react';
import PropTypes from 'prop-types';
import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';
import { Button } from 'components/landing/components';

const dumbServices = dumbBem('l-services');
const HeaderBlock = tx([{ element: 'header-block' }, dumbServices])('div');

const HeaderButtons = ({
  buttons,
  scrollToBlock,
  blockRefs,
}) => {
  return (
    <React.Fragment>
      {buttons.map(button => (
        <HeaderBlock key={button.ref}>
          <Button
            onClick={() => scrollToBlock(blockRefs[button.ref])}
            modifier="reversed-colors"
          >
            {button.title}
          </Button>
        </HeaderBlock>
      ))}
    </React.Fragment>
  );
};

HeaderButtons.propTypes = {
  buttons: PropTypes.array.isRequired,
  scrollToBlock: PropTypes.func.isRequired,
  blockRefs: PropTypes.object.isRequired,
};

export default HeaderButtons;



// WEBPACK FOOTER //
// ./src/components/landing/pages/services/HeaderButtons.jsx